// extracted by mini-css-extract-plugin
export default {"movieName":"Movie_movieName__SkUmK","movie":"Movie_movie__UI4Bg","movieTitle":"Movie_movieTitle__TIYSe","main":"Movie_main__IIh0h"};